import { pipe, prop, propEq, groupBy, map, toPairs, propOr } from 'ramda'
import { findOr } from '@v/util/briqRamdaExt.js'

const getExistingQuantity = (classificationCode, segmentCode) =>
  pipe(
    prop('QuantitiesPerClassification'),
    findOr(0, propEq('ClassificationCode', classificationCode)),
    propOr(0, 'QuantitiesPerSegment'),
    findOr(0, propEq('SegmentCode', segmentCode)),
    propOr(0, 'Quantity'),
  )

const resolveActiveSegments = (flatSegments, bookingProduct) =>
  pipe(
    prop('ActiveSegments'),
    groupBy(prop('ClassificationCode')),
    toPairs,
    map(([classificationCode, activeSegmentsForClassification]) => ({
      ClassificationCode: classificationCode,
      QuantitiesPerSegment: activeSegmentsForClassification.map(
        pipe(prop('SegmentCode'), segmentCode => {
          const segmentDetails = flatSegments.find(propEq('Code', segmentCode))
          const Quantity = getExistingQuantity(classificationCode, segmentCode)(bookingProduct)
          return {
            Quantity,
            SegmentCode: segmentCode,
            SegmentName: segmentDetails.NamePlural,
            Order: segmentDetails.Order || segmentDetails.Ordering,
          }
        }),
      ),
    })),
  )

export const completeQuantities = (product, flatSegments, bookingProduct) => {
  return resolveActiveSegments(flatSegments, bookingProduct)(product)
}
